import { Component, Input } from '@angular/core';
import { Value } from '../../../classes/value';

export interface ProgressOptions {
    value: number,
    classes: 'danger' | 'warning' | 'info' | 'default' | 'primary' | 'success' | string,
}

@Component({
    selector: 'chassis-datatable-value-progress',
    templateUrl: './progress.component.html',
    styleUrls: ['./progress.component.scss'],
})
export class ProgressComponent extends Value<ProgressOptions> {

    @Input() data: ProgressOptions;

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/values/progress/progress.component.ts